import React, { Fragment, useEffect, useState } from "react";
import { Card, Col, Container, Row } from "react-bootstrap";
import blobLhs from "@styles/assets/images/careers/blob-lhs.png";
import blobrhs from "@styles/assets/images/careers/blob-rhs.png";
import { StaticImage } from "gatsby-plugin-image";
import { utils } from "@core/helper";
import { Link } from "gatsby";
import MyVerticallyCenteredModal from "./mailpopup";
import { collectionKeys } from "@core/helper/utils";

const CareersScreen = (props) => {
  const { db } = props;
  const [isOpen, setIsOpen] = useState(false);
  const [careersData, setCareersData] = useState([]);
  const [isMounted, setIsMounted] = useState(false);

  const loadBlogsList = async (db) => {
    try {
      const { data } = await utils.fetchPaginatedData(
        db,
        collectionKeys.CAREER,
        "lastUpdate",
        6
      );
      setCareersData(data);
    } catch (error) {
      console.error("er::", error);
    }
  };

  useEffect(() => {
    if (isMounted && db) {
      loadBlogsList(db);
    }
  }, [isMounted, db]);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  return (
    <Fragment>
      <section className="careers_wrapper">
        <Container>
          <Row className="rg_30">
            <Col
              md={7}
              className="d-flex d-md-block justify-content-center align-items-center p-md-0"
            >
              <div className="careers_hero_lhs ms-md-auto">
                <h1>Join our Team</h1>
                <p>
                  We're a global team united by a shared mission—to make amazing
                  software easy to build and accessible to everyone.{" "}
                  <span className="d-block">
                    Join our journey to empower the world through technology!
                  </span>
                </p>
                {/* <span
                  onClick={() => handleScrollOpenings("current_openings")}
                  className="careers_btn"
                >
                  See Open Positions
                </span> */}
              </div>
            </Col>
            <Col
              md={5}
              className="d-flex d-md-block justify-content-center align-items-center p-md-0"
            >
              <StaticImage
                alt="officers"
                width={360}
                height={407}
                src="../../styles/assets/images/careers/officers.png"
                formats={["auto", "webp", "png"]}
              />
            </Col>
          </Row>
        </Container>
        <img className="careers_blob_left" src={blobLhs} alt="blob" />
        <img className="careers_blob_right" src={blobrhs} alt="blob" />
      </section>
      <section className="careers_space_layout">
        <Container>
          <Row>
            <Col md={12}>
              <div className="careers_mission">
                <h2 data-aos="fade-up" data-aos-delay="500">
                  Our mission
                </h2>
                <p data-aos="fade-up" data-aos-delay="600">
                  Our goal is to design cutting-edge websites that empower
                  businesses in today's fiercely competitive market, elevating
                  brand visibility and setting the stage for future success. By
                  blending creativity with strategic insights, we craft digital
                  experiences that captivate audiences and drive results. Join
                  us as we redefine the digital landscape and empower businesses
                  to thrive in an ever-evolving world.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <section className="careers_space_layout">
        <Container>
          <Row className="joblist_row">
            <Col md={12}>
              <div id="current_openings" className="careers_mission">
                <h2 data-aos="fade-up" data-aos-delay="500">
                  Current Openings
                </h2>
              </div>
            </Col>
            {/* {jobData.map((job, ind) => {
              return (
                <Col
                  key={ind}
                  lg={4}
                  sm={6}
                  className="d-flex align-items-center justify-content-center"
                >
                  <Card
                    className="joblist_cards"
                    key={job.id}
                    onClick={() => {
                      setIsOpen(true);
                    }}
                  >
                    <Card.Header>{job.position}</Card.Header>
                    <Card.Body>
                      <p>
                        Department: <span>{job.department}</span>
                      </p>
                      <p>
                        Job Type: <span>{job.type}</span>
                      </p>
                      <p>
                        Duration: <span>{job.duration}</span>
                      </p>
                      <p>
                        Benefits: <span>{job.benefits}</span>
                      </p>
                    </Card.Body>
                  </Card>
                </Col>
              );
            })} */}

            {careersData.map((job, ind) => {
              return (
                <Col
                  key={ind}
                  lg={4}
                  sm={6}
                  className="d-flex align-items-center justify-content-center"
                >
                  <Card
                    className="joblist_cards"
                    key={job.id}
                    onClick={() => {
                      setIsOpen(true);
                    }}
                  >
                    <Card.Header>{job.title}</Card.Header>
                    <Card.Body>
                      <p dangerouslySetInnerHTML={{ __html: job?.content }}></p>
                    </Card.Body>
                  </Card>
                </Col>
              );
            })}
          </Row>
        </Container>
      </section>
      <MyVerticallyCenteredModal
        show={isOpen}
        onHide={() => setIsOpen(false)}
      />
      <section className="careers_perks">
        <Container>
          <Row className="rg_50">
            <Col md={12}>
              <h2 className="text-center">Perks of the job</h2>
            </Col>
            <Col
              lg={{ span: 5, offset: 1 }}
              className="d-flex d-lg-block justify-content-center align-items-center"
            >
              <ul>
                <li>
                  <p>
                    <span>{utils.tick()}</span>
                    Hybrid working model
                  </p>
                </li>
                <li>
                  <p>
                    <span>{utils.tick()}</span>
                    Work-Life Balance Policies
                  </p>
                </li>
                <li>
                  <p>
                    <span>{utils.tick()}</span>
                    Performance-based Rewards
                  </p>
                </li>
                <li>
                  <p>
                    <span>{utils.tick()}</span>
                    Learning and development budget
                  </p>
                </li>
                <li>
                  <p>
                    <span>{utils.tick()}</span>
                    Family friendly policies
                  </p>
                </li>
              </ul>
            </Col>
            <Col
              lg={6}
              className="d-flex d-lg-block justify-content-center align-items-center"
            >
              <ul>
                <li>
                  <p>
                    <span>{utils.tick()}</span>
                    Regular team and company-wide celebrations
                  </p>
                </li>
                <li>
                  <p>
                    <span>{utils.tick()}</span>
                    Flexible Working Hours
                  </p>
                </li>
                <li>
                  <p>
                    <span>{utils.tick()}</span>
                    Team Building Activities
                  </p>
                </li>
                <li>
                  <p>
                    <span>{utils.tick()}</span>
                    Supportive Management
                  </p>
                </li>
                <li>
                  <p>
                    <span>{utils.tick()}</span>
                    Collaborative Work Environment
                  </p>
                </li>
              </ul>
            </Col>
          </Row>
        </Container>
      </section>
      <section className="careers_future">
        <Container>
          <Row className="rg_50">
            <Col md={12}>
              <h2
                className="text-center mx-auto"
                data-aos="fade-up"
                data-aos-delay="400"
              >
                The first steps to your future
              </h2>
            </Col>
            <Col md={12}>
              <p
                className="careers_future_description"
                data-aos="fade-up"
                data-aos-delay="500"
              >
                From the moment you apply, our exceptional people team will
                guide you through the recruitment journey. Upon success, you'll
                embark on a personalized onboarding adventure to seamlessly
                integrate you into our family. Plus, you'll have your very own
                Mentor Mate for ongoing support and check-ins to ensure you're
                equipped for success.
              </p>
            </Col>
            <Col
              md={4}
              className="mx-auto col_flex"
              data-aos="fade-up"
              data-aos-delay="600"
            >
              <StaticImage
                alt="students"
                width={400}
                height={266.5}
                src="../../styles/assets/images/careers/students.png"
                formats={["auto", "webp", "png"]}
              />
            </Col>
          </Row>
        </Container>
      </section>
      <section className="careers_perks">
        <Container>
          <Row className="rg_50">
            <Col md={12}>
              <h2 className="text-center">
                Anticipate the Application Journey
              </h2>
            </Col>
            <Col md={10} className="mx-auto">
              <p className="text-center">
                Our streamlined recruitment process is designed to help us
                understand you better while providing you with insight into the
                culture and opportunities at justtrytech.com. Your questions
                (and ideas) are encouraged at every stage!
              </p>
            </Col>
            <Col
              lg={3}
              md={6}
              className="d-flex justify-content-center align-items-center d-md-block"
            >
              <Card className="journey_card">
                <Card.Header>
                  <div className="app_count">1</div>
                  <p>Nice to meet you</p>
                </Card.Header>
                <Card.Body>
                  <Card.Text>
                    In the initial stage, we aim to delve deeper into who you
                    are as an individual and your professional background.
                    Additionally, we'll provide an overview of the position
                    you're seeking and introduce you to the dynamic Justtry
                    team.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col
              lg={3}
              md={6}
              className="d-flex justify-content-center align-items-center d-md-block"
            >
              <Card className="journey_card">
                <Card.Header>
                  <div className="app_count">2</div>
                  <p>Show us your skills</p>
                </Card.Header>
                <Card.Body>
                  <Card.Text>
                    Depending on the nature of the position you've applied for,
                    this step offers you an opportunity to showcase your skill
                    set either through a task/assignment or by providing us with
                    a comprehensive overview of your background.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col
              lg={3}
              md={6}
              className="d-flex justify-content-center align-items-center d-md-block"
            >
              <Card className="journey_card">
                <Card.Header>
                  <div className="app_count">3</div>
                  <p>Do we feel the same?</p>
                </Card.Header>
                <Card.Body>
                  <Card.Text>
                    This session entails competency-based questions tailored to
                    our company's values (HEART). It's also your chance to
                    confirm that our values resonate with your own.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col
              lg={3}
              md={6}
              className="d-flex justify-content-center align-items-center d-md-block"
            >
              <Card className="journey_card">
                <Card.Header>
                  <div className="app_count">4</div>
                  <p>Final Conversation</p>
                </Card.Header>
                <Card.Body>
                  <Card.Text>
                    Time for Feedback! We strive to promptly provide feedback
                    post-culture interview. Hopefully, this is where you'll
                    receive a job offer!
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>
      <Container>
        <Row className="mt_50">
          <Col md={12} className="col_flex">
            <Link to="/careers/current-openings/" className="careers_btn">
              See Open Positions
            </Link>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default CareersScreen;
